import * as React from 'react';
import Languages from 'lib/Languages';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  showOriginal: boolean;
  originalLanguageCode: string;
  onToggleShowOriginal: () => void;
};

import './styles/MessageBodyTranslationSwitcher.scss';

export default function MessageBodyTranslationSwitcher(props: Props) {
  const renderSwitcherBody = (langCode?: string) => {
    if (props.showOriginal) {
      return <span>&lt; Back to translation</span>;
    } else {
      if (langCode && Languages[langCode]?.name) {
        return (
          <span>
            Translated from <b>{Languages[langCode].name}</b> &gt;
          </span>
        );
      } else {
        return <span>Translated &gt;</span>;
      }
    }
  };

  const hasNewTranslationsEnabled =
    CurrentUser.isSignedIn() &&
    CurrentUser.getUser() &&
    CurrentUser.getUser().hasFeature('2020.dec.preferred_language_translation_v0');

  return hasNewTranslationsEnabled ? (
    <div
      onClick={props.onToggleShowOriginal}
      data-test="message-body-translation-switcher"
      className="MessageBodyTranslationSwitcher">
      {renderSwitcherBody(props.originalLanguageCode)}
    </div>
  ) : null;
}
